import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { TableLoader } from '../../../../library/table-loader'
import DashboardSingleListLeftContainerCompanyRow from './table-row'

import './style.scss'

const Index = ({searchQuery, maintainLayout}) => {

	const fetchLoading = useSelector(state => state.singleList.fetchFullList.loading)
	const list = useSelector(state => state.singleList.list)

	const [limit, setLimit] = useState(25)
	const [listDisplay, setListDisplay] = useState([])


	useEffect(() => {
		if(!fetchLoading){
			if(list && list.length > 0){
				const initialDisplay = list.slice(0, limit)
				setListDisplay(initialDisplay)
			}
		}
	}, [list, fetchLoading, limit])

	const handleLoadMore = () => {
		if(limit <= list.length - 25){
			const newCount = limit + 25
			setLimit(newCount)
		} else {
			const restCount = limit + (list.length - limit)
			setLimit(restCount)
		}
	}
	
	return(
		<div className="table-list-container">
			<table>
				<tr>
					<th>BEDRIFTSNAVN</th>
					<th></th>
					<th>RESPONS</th>
					<th></th>
				</tr>
				{!maintainLayout ?
					<>
						{!fetchLoading && list && listDisplay.map((singleCompany, index, arr) => {
							if(!searchQuery){
								return(
									<DashboardSingleListLeftContainerCompanyRow singleCompany={singleCompany} displayIndex={index}/>
								)
							} else {
								if(singleCompany.navn.toLowerCase().includes(searchQuery.toLowerCase())){
									return(
										<DashboardSingleListLeftContainerCompanyRow singleCompany={singleCompany} displayIndex={index}/>
									)
								}
							}
						})}
					</>
				:
				<>
				{list && listDisplay.map((singleCompany, index) => {
					if(!searchQuery){
						return(
							<DashboardSingleListLeftContainerCompanyRow singleCompany={singleCompany} displayIndex={index}/>
						)
					} else {
						if(singleCompany.navn.toLowerCase().includes(searchQuery.toLowerCase())){
							return(
								<DashboardSingleListLeftContainerCompanyRow singleCompany={singleCompany} displayIndex={index}/>
							)
						}
					}
				})}
				</>
				}
			</table>
			{fetchLoading && !maintainLayout ? <TableLoader/>:null}
			{!fetchLoading && list && Object.keys(list).length > 0 && limit < Object.keys(list).length ? <button onClick={handleLoadMore} className="load-more-button">Hent flere virksomheter</button>:null}
		</div>
	)
}

export default Index




